export default __webpack_public_path__ + "static/media/logo.031c991b.png";